import { useStore } from '@tanstack/react-store';

import { setTheme, type Theme, themeStore } from '../stores/theme-store';

export type { Theme };

export function useTheme() {
  const theme = useStore(themeStore, (s) => s.theme);
  return { theme, setTheme };
}
